import {language as lan_selectStore} from "./select-store";
import { language as lan_selectProductType} from "./select-product-type";

let language = {
    // 选择店铺
    ...lan_selectStore,
    //选择店铺产品类型
    ...lan_selectProductType

};

export { language }